import { useLocation } from 'react-router';
import { match, Pattern } from 'ts-pattern';

import { Redirect } from '~/components';
import { AnchorTargets } from '~/constants/url';
import { routes } from '~/providers/RouterProvider/router.routes';

export const SettingsGeneralRedirect = () => {
  const { hash } = useLocation();

  const to = match(hash.slice(1))
    .with(
      Pattern.union(AnchorTargets.SETTINGS_PROFILE_INFO, AnchorTargets.SETTINGS_PROFILE_COMMUNITY, AnchorTargets.SETTINGS_PROFILE_PASSWORD),
      () => routes.settingsProfile,
    )
    .with(AnchorTargets.SETTINGS_EMAIL_SETTINGS, () => routes.settingsEmail)
    .with(
      Pattern.union(
        AnchorTargets.SETTINGS_INVOICE_THEME,
        AnchorTargets.SETTINGS_INVOICE_NUMBERING_SERIES,
        AnchorTargets.SETTINGS_INVOICE_CUSTOM_CONDITIONS,
      ),
      () => routes.settingsInvoice,
    )
    .with(
      Pattern.union(
        AnchorTargets.SETTINGS_COMPANY_INFO,
        AnchorTargets.SETTINGS_COMPANY_ACTIVITIES,
        AnchorTargets.SETTINGS_COMPANY_FINANCIAL,
        AnchorTargets.SETTINGS_COMPANY_VAT_REGULATION,
        AnchorTargets.SETTINGS_COMPANY_BRANDS,
        AnchorTargets.SETTINGS_COMPANY_ACCOUNTANT,
      ),
      () => routes.settingsCompany,
    )
    .with(
      Pattern.union(
        AnchorTargets.SETTINGS_INTEGRATIONS_PEPPOL,
        AnchorTargets.SETTINGS_INTEGRATIONS_AUTO_FORWARDING,
        AnchorTargets.SETTINGS_INTEGRATIONS_EXTERNAL_SERVICES,
      ),
      () => routes.settingsIntegrations,
    )
    .otherwise(() => routes.settingsProfile);

  return <Redirect to={to} />;
};
